import { Label } from 'components/ui/label';
import { Switch } from 'components/ui/switch';
import { ColorPicker } from 'components/Inputs/ColorPicker';
import { ListBoxInput } from 'components/Inputs/ListBoxInput';
import MultiRangeSlider from 'components/Inputs/MultiRangeSlider';
import { useAllowedDataKeys } from 'hooks/useAllowedDataKeys';
import { useChartConfig } from 'hooks/useChartConfig';

export const BubbleForm = () => {
  const {
    chart: {
      props: { swapAxis, bubble },
    },
    updateChartProps,
  } = useChartConfig();
  const { domainKeyOptions } = useAllowedDataKeys();
  return (
    <div>
      <form className="flex flex-col gap-2">
        <div>
          <h3 className="mb-2">Champ</h3>
          <ListBoxInput<string>
            defaultValue={bubble.domainKey}
            options={domainKeyOptions}
            onChange={(domainKey: string) => {
              updateChartProps({
                bubble: { ...bubble, domainKey },
              });
            }}
          />
        </div>
        <div className="my-2">
          <h3 className="mb-2">Inverser les axes</h3>
          <div className="flex items-center space-x-2">
            <Switch
              id="bubble-swap-axis-toggle"
              checked={swapAxis}
              onCheckedChange={(isEnabled) =>
                updateChartProps({ swapAxis: isEnabled })
              }
            />
            <Label htmlFor="bubble-swap-axis-toggle" className="cursor-pointer">
              Inverser les axes
            </Label>
          </div>
        </div>
        <div className="my-2">
          <h3 className="mb-2">Couleur</h3>
          <ColorPicker
            defaultColor={'#000000'}
            onChange={(fill: string) =>
              updateChartProps({ bubble: { ...bubble, fill } })
            }
          />
        </div>
        <div className="my-2">
          <h3>Rayon des bulles</h3>
          <MultiRangeSlider
            onChange={({ min, max }) =>
              updateChartProps({
                bubble: { ...bubble, minRadius: min, maxRadius: max },
              })
            }
            min={0}
            max={100}
          />
        </div>
      </form>
    </div>
  );
};
